module.exports = __webpack_public_path__ + "app/kiss-user/impersonate-user-modal-nFzqRpms.html";